export default {
  "grapesjs-undraw": {},
};
